import { render, staticRenderFns } from "./AdminGroupList.vue?vue&type=template&id=3f90953a"
import script from "./AdminGroupList.vue?vue&type=script&lang=js"
export * from "./AdminGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports